// extracted by mini-css-extract-plugin
export default {"main_container":"header_component_main_container__qCZ07","logo_container":"header_component_logo_container__Pett9","logo_size":"header_component_logo_size__bpRiP"};